import { officialUrl, openPlatformUrl, onlineServiceUrl } from "./api";

import secondIcon01 from "@/assets/images/header/secondIcon01.png";
import secondIcon02 from "@/assets/images/header/secondIcon02.png";
import secondIcon03 from "@/assets/images/header/secondIcon03.png";
import secondIcon04 from "@/assets/images/header/secondIcon04.png";
import secondIcon05 from "@/assets/images/header/secondIcon05.png";
import secondIcon06 from "@/assets/images/header/secondIcon06.png";

import threeIcon01 from "@/assets/images/header/threeIcon01.png";
import threeIcon02 from "@/assets/images/header/threeIcon02.png";
import threeIcon03 from "@/assets/images/header/threeIcon03.png";
import threeIcon04 from "@/assets/images/header/threeIcon04.png";

import first_nav_icon01 from "@/assets/images/header/first_nav_icon01.svg";
import first_nav_icon02 from "@/assets/images/header/first_nav_icon02.svg";
import first_nav_icon03 from "@/assets/images/header/first_nav_icon03.svg";
import first_nav_icon04 from "@/assets/images/header/first_nav_icon04.svg";
import first_nav_icon05 from "@/assets/images/header/first_nav_icon05.svg";
import first_nav_icon06 from "@/assets/images/header/first_nav_icon06.svg";
import first_nav_icon07 from "@/assets/images/header/first_nav_icon07.svg";

import first_nav_active01 from "@/assets/images/header/first_nav_active01.svg";
import first_nav_active02 from "@/assets/images/header/first_nav_active02.svg";
import first_nav_active03 from "@/assets/images/header/first_nav_active03.svg";
import first_nav_active04 from "@/assets/images/header/first_nav_active04.svg";
import first_nav_active05 from "@/assets/images/header/first_nav_active05.svg";
import first_nav_active06 from "@/assets/images/header/first_nav_active06.svg";
import first_nav_active07 from "@/assets/images/header/first_nav_active07.svg";

export const firstNavIconList = [
  first_nav_icon01.src,
  first_nav_icon02.src,
  first_nav_icon03.src,
  first_nav_icon04.src,
  first_nav_icon05.src,
  first_nav_icon06.src,
  first_nav_icon07.src,
  first_nav_icon07.src,
];
export const firstActiveIconList = {
  0: first_nav_active01.src,
  1: first_nav_active02.src,
  2: first_nav_active03.src,
  3: first_nav_active04.src,
  4: first_nav_active05.src,
  5: first_nav_active06.src,
  6: first_nav_active07.src,
  7: first_nav_active07.src,
};



export const htmlSuffix = process.env.HTML_SUFFIX;
export const publicPath = process.env.HOME_PATH;
//export const publicPath = process.env.CURRENT_ENV=='dev'?'/site':'/site2025/site'

const homeList = [
  {
    title: "首页",
    href: "/",
    children: [],
  },
];
export const productNavList = [
  {
    title: "即时通讯",
    icon: secondIcon01.src,
    children: [
      {
        title: "企业级即时通讯",
        href: publicPath + "/instant" + htmlSuffix,
      },
      {
        title: "信创即时通讯",
        href: publicPath + "/xinchuang" + htmlSuffix,
      },
      {
        title: "涉密即时通讯",
        href: publicPath + "/secret" + htmlSuffix,
      },
      {
        title: "IM-SDK组件",
        href: publicPath + "/imintegration" + htmlSuffix,
      },
      {
        title: "视频会议",
        href: publicPath + "/videoconference" + htmlSuffix,
      },
    ],
  },
  {
    title: "业务协同",
    icon: secondIcon02.src,
    children: [
      {
        title: "统一智能门户平台",
        href: publicPath + "/workportal" + htmlSuffix,
      },
      {
        title: "移动门户平台",
        href: publicPath + "/mobileportal" + htmlSuffix,
      },
      {
        title: "低代码平台",
        href: publicPath + "/lowcodeplatform" + htmlSuffix,
      },
      {
        title: "云文档",
        href: publicPath + "/clouddocument" + htmlSuffix,
      },
    ],
  },
  {
    title: "智能底座",
    icon: secondIcon06.src,
    children: [
      {
        title: "智能客服",
        href: publicPath + "/intelligentservice" + htmlSuffix,
      },
      {
        title: "Agent平台",
        href: publicPath + "/agentplatform" + htmlSuffix,
      },
      {
        title: "AI训推平台",
        href: publicPath + "/instructplatfrom" + htmlSuffix,
      },
    ],
  },
];
const productPcNav = [
  {
    title: "产品功能",
    threeRank: true,
    colSpan: 6,
    children: productNavList,
  },
];

const resolveNavList = [
  {
    title: "城市人工智能平台",
    href: publicPath + "/policeplatform/aibase" + htmlSuffix,
  },
  {
    title: "新一代智能警务协同平台",
    href: publicPath + "/policeplatform/newpolicepla" + htmlSuffix,
  },
  {
    title: "安全运营协同处置平台",
    href: publicPath + "/policeplatform/operatepla" + htmlSuffix,
  },
  {
    title: "一体化涉密信创协作平台",
    href: publicPath + "/policeplatform/collaboratepla" + htmlSuffix,
  },
];

// const productPcNav: any = [
//     {
//     title: '产品功能',
//     id:"product",
//     children: productNavList
//     }
// ]

const resolvePcNav = [
  {
    title: "解决方案",
    colSpan: 6,
    children: resolveNavList,
  },
];
const productNav = [
  {
    title: "热门产品",
    colspan: 4,
    children: [
      {
        title: "企业级即时通讯",
        href: publicPath + "/instant" + htmlSuffix,
      },
      {
        title: "涉密即时通讯",
        href: publicPath + "/secret" + htmlSuffix,
      },
      {
        title: "统一智能门户平台",
        href: publicPath + "/workportal" + htmlSuffix,
      },
      {
        title: "Agent平台",
        href: publicPath + "/agentplatform" + htmlSuffix,
      },
      {
        title: "AI训推平台",
        href: publicPath + "/instructplatfrom" + htmlSuffix,
      },
    ],
  },
];

const resolveNav = [
  {
    title: "解决方案",
    colspan: 5,
    colspanlg: 5,
    children: [
      {
        title: "城市人工智能平台",
        href: publicPath + "/policeplatform/aibase" + htmlSuffix,
      },
      {
        title: "新一代智能警务协同平台",
        href: publicPath + "/policeplatform/newpolicepla" + htmlSuffix,
      },
      {
        title: "安全运营协同处置平台",
        href: publicPath + "/policeplatform/operatepla" + htmlSuffix,
      },
      {
        title: "一体化涉密信创协作平台",
        href: publicPath + "/policeplatform/collaboratepla" + htmlSuffix,
      },
    ],
  },
];
const serviceNav = [
  {
    title: "服务中心",
    colspan: 3,
    colspanlg: 3,
    children: [
      {
        title: "在线客服",
        href: onlineServiceUrl,
      },

      {
        title: "客户服务",
        href: publicPath + "/about/service" + htmlSuffix,
      },
    //   {
    //     title: "生态合作",
    //     href: officialUrl + commonPath + "cooper.html",
    //   },
      // {
      //     title: '开放平台文档',
      //     href: openPlatformUrl,
      // }
    ],
  },
];
const contactChildren = [
  {
    title: "公司介绍",
    href: publicPath + "/about/company" + htmlSuffix,
  },
  {
    title: "荣誉资质",
    href: publicPath + "/about/honor" + htmlSuffix,
  },
  {
    title: "客户服务",
    href: publicPath + "/about/service" + htmlSuffix,
  },
  {
    title: "生态合作",
    href: publicPath + "/about/cooper" + htmlSuffix,
  }
];
const contactNav: any = [
  {
    title: "关于我们",
    id: "about",
    colspanlg: 3,
    children: [
      {
        title: "公司介绍",
        href: publicPath + "/about/company" + htmlSuffix,
      },
      {
        title: "荣誉资质",
        href: publicPath + "/about/honor" + htmlSuffix,
      },
      {
        title: "新闻动态",
        href: officialUrl + '/new/',
      },
      {
        title: "生态合作",
        href: publicPath + "/about/cooper" + htmlSuffix,
      }
    ],
  },
];


export const registers = publicPath + '/register' + htmlSuffix
export const registerSsuccess = publicPath + '/registersuccess' + htmlSuffix
export const headerNavOut = (type?: string) => {
  let mobileNav: any[] = [...productNav, ...resolveNav];
  if (type === "pc") {
    mobileNav = [
      ...productPcNav,
      //...resolveNav
      ...resolvePcNav,
    ];
  }
  return [
    ...homeList,
    // {
    //     title: '优势特色',
    //     href:  publicPath + '/advantage' + htmlSuffix,
    //     children: []
    // },
    ...mobileNav,
    {
      title: "涉密信创",
      href: publicPath + "/xinchuang" + htmlSuffix,
      children: [],
    },
    {
      title: "新闻中心",
      href: officialUrl + '/new/',
      children: [],
    },
    {
      title: "渠道合作",
      href: publicPath + "/about/cooper" + htmlSuffix,
      children: [],
    },
   
    {
      title: "开放平台",
      href: openPlatformUrl,
      children: [],
    },
    {
      title: "关于我们",
      id: "about",
      children: [
        ...contactChildren,
        {
          title: "在线客服",
          href: onlineServiceUrl,
        },
      ],
    },
  ];
};

export const footerNavList = [
  ...productNav,
  ...resolveNav,
  ...serviceNav,
  ...contactNav,
];
export const concatInfo800 = [
  {
    title: "联系我们",
    children: [
      {
        title: "市场合作 mailto:ccwork@360.cn",
        href: "mailto:ccwork@360.cn",
      },
      {
        title: "客服热线 400 021 0360",
        href: "tel:4000210360",
      },
      {
        title: "北京地址 北京市朝阳区酒仙桥路6号院360大厦",
        href: "",
      },
      {
        title: "上海地址 普陀区祁连山路111弄中以创新园17号楼",
        href: "",
      },
    ],
  },
];
export const footerNavList800 = [
  ...productNav,
  ...resolveNav,
  ...serviceNav,
  ...contactNav,
  ...concatInfo800,
];

export const concatInfo = {
  title: "联系我们",
  list: [
    {
      tit: "市场合作",
      content: "ccwork@360.cn",
      href: "mailto:ccwork@360.cn",
    },
    {
      tit: "客服热线",
      href: "tel:4000210360",
      content: "400 021 0360",
    },
    {
      tit: "北京地址",
      content: "北京市朝阳区酒仙桥路6号院360大厦",
    },
    {
      tit: "上海地址",
      content: "普陀区祁连山路111弄中以创新园17号楼",
    },
  ],
};

export const friendLinkList = [
  {
    title: "360集团",
    url: "https://www.360.cn/",
  },
  {
    title: "360网址导航",
    url: "https://hao.360.com/",
  },
  {
    title: "企业网盘",
    url: "https://www.fangcloud.com/",
  },
];
